module.exports = __webpack_public_path__ + "static/fonts/akrobat-regular.f1abe740.ttf";